import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutUs = ({ embedded = false, onOpenFeedback = null }) => {
  const navigate = useNavigate();

  const sectionStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '14px',
    padding: '22px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    marginBottom: '18px',
  };

  return (
    <div
      style={{
        minHeight: embedded ? 'auto' : 'calc(100vh - 70px)',
        backgroundColor: '#f7f9fc',
        padding: embedded ? '4px 0 24px' : '28px 18px 40px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div
          style={{
            background: 'linear-gradient(135deg, #1976d2 0%, #0f5ca8 100%)',
            color: '#fff',
            borderRadius: '16px',
            padding: '32px 28px',
            marginBottom: '20px',
            boxShadow: '0 4px 14px rgba(25,118,210,0.18)',
          }}
        >
          <div style={{ fontSize: '34px', marginBottom: '8px' }}>💬</div>
          <h1 style={{ margin: 0, fontSize: '2rem', lineHeight: 1.2 }}>
            Why iBoard AAC Exists
          </h1>
          <p
            style={{
              margin: '12px 0 0',
              fontSize: '1.08rem',
              lineHeight: 1.7,
              maxWidth: '760px',
              opacity: 0.96,
            }}
          >
            iBoard AAC began with one simple purpose: to help my daughter communicate
            her wants, needs and thoughts in a way that worked for her.
          </p>
        </div>

        <section style={sectionStyle}>
          <h2 style={{ marginTop: 0, color: '#1f2937' }}>A personal beginning</h2>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            My daughter has a brain malformation which has resulted in global
            developmental delay and significant speech difficulties. She is unable
            to rely on spoken language to communicate her wants and needs, so finding
            the right way for her to express herself has always been incredibly
            important to our family.
          </p>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            When we began looking at AAC solutions, many of the options available
            were either too complex for her level of understanding at that time or
            simply too expensive. I wanted something that could start simple and
            then grow alongside her as her needs, skills and understanding developed.
            That is why I created iBoard AAC.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={{ marginTop: 0, color: '#1f2937' }}>Built to grow with the person</h2>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            The app was designed around flexibility rather than a one-size-fits-all
            approach. Boards can begin small and straightforward, then become richer
            and more personalised over time. The goal has always been to make AAC
            feel approachable while still leaving room for the system to develop
            with the person using it.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={{ marginTop: 0, color: '#1f2937' }}>From our family to others</h2>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            iBoard AAC was never originally created as a business or as a way to
            make money. It was built for my daughter. Over time, however,
            professionals involved in her care and development saw the app and asked
            whether they could use it with other people they support.
          </p>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            That interest encouraged me to develop the project further and make it
            available to other families, carers and professionals who may benefit
            from it.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={{ marginTop: 0, color: '#1f2937' }}>Why there is a paid option</h2>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            As more people use the service, the cost of hosting, storage, development
            and maintaining the systems behind it also increases. The paid side of
            iBoard AAC exists to help cover those ongoing costs and allow the service
            to remain reliable and continue developing.
          </p>
          <p style={{ color: '#4b5563', lineHeight: 1.75, fontSize: '1rem' }}>
            The purpose of the project remains the same as it was on day one:
            making communication more accessible to people who need another way to
            be heard.
          </p>
        </section>

        <section
          style={{
            ...sectionStyle,
            border: '1px solid #cfe4ff',
            backgroundColor: '#f3f8ff',
          }}
        >
          <h2 style={{ marginTop: 0, color: '#0f5ca8' }}>Help shape what comes next</h2>
          <p style={{ color: '#374151', lineHeight: 1.75, fontSize: '1rem' }}>
            Every person's communication needs are different. If your loved one,
            someone you care for, or someone you support needs a particular AAC
            feature that iBoard AAC does not currently provide, please use the
            Feedback / Request form and tell me about it.
          </p>
          <p style={{ color: '#374151', lineHeight: 1.75, fontSize: '1rem' }}>
            I cannot promise that every request will be possible, but I will always
            try my very best to understand the need and help where I can.
          </p>

          <div
            style={{
              marginTop: '20px',
              padding: '18px',
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              border: '1px solid #dbeafe',
              textAlign: 'center',
            }}
          >
            <strong
              style={{
                display: 'block',
                fontSize: '1.35rem',
                color: '#1976d2',
                marginBottom: '12px',
              }}
            >
              Everyone deserves a voice.
            </strong>

            <button
              type="button"
              onClick={() => onOpenFeedback ? onOpenFeedback() : navigate('/profile')}
              style={{
                padding: '10px 18px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: '#1976d2',
                color: '#fff',
                fontSize: '15px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              💬 Feedback / Request
            </button>
          </div>
        </section>

        <p
          style={{
            textAlign: 'center',
            color: '#6b7280',
            lineHeight: 1.7,
            margin: '24px 0 0',
          }}
        >
          Thank you for supporting iBoard AAC and for being part of its journey.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
